<template>
  <div>
      <div class="w">
          <HeadNav activeIndex="2" textColor="#333"></HeadNav>
      </div>
      <div class="survey-banner">
         <!-- <router-link to="my"><div class="banner-btn" style="text-align:center;">立即使用</div></router-link> -->
         <router-link to="my"><div class="bgcImage" style="">立即使用</div></router-link>
      </div>
      <div class="w">
          <div class="survey-title flex column justify-content align-items">
              <div>功能强大</div>
              <div class="border"></div>
          </div>
          <div class="icon-list">
              <el-row :gutter="60">
                  <el-col :span="8">
                      <el-card  class="card flex column justify-content" :body-style="{ padding: '0px' }">
                          <div class="flex justify-content" style="padding: 20px 0">
                              <img src="../assets/list_icon1.png" class="image">
                          </div>
                          <div class="flex justify-content card-font" >
                              <span style="font-size: 24px">问卷设计</span>
                          </div>
                      </el-card>
                  </el-col>
                  <el-col :span="8">
                      <el-card  class="card flex column justify-content" :body-style="{ padding: '0px' }">
                          <div class="flex justify-content" style="padding: 20px 0">
                              <img src="../assets/list_icon2.png" class="image">
                          </div>
                          <div class="flex justify-content card-font" >
                              <span style="font-size: 24px">逻辑设置</span>
                          </div>
                      </el-card>
                  </el-col>
                  <el-col :span="8">
                      <el-card  class="card flex column justify-content" :body-style="{ padding: '0px' }">
                          <div class="flex justify-content" style="padding: 20px 0">
                              <img src="../assets/list_icon3.png" class="image">
                          </div>
                          <div class="flex justify-content card-font" >
                              <span style="font-size: 24px">多种题型</span>
                          </div>
                      </el-card>
                  </el-col>
              </el-row>
              <el-row :gutter="60" style="margin-top: 30px">
                  <el-col :span="8">
                      <el-card  class="card flex column justify-content" :body-style="{ padding: '0px' }">
                          <div class="flex justify-content" style="padding: 20px 0">
                              <img src="../assets/list_icon4.png" class="image">
                          </div>
                          <div class="flex justify-content card-font" >
                              <span style="font-size: 24px">断点续答</span>
                          </div>
                      </el-card>
                  </el-col>
                  <el-col :span="8">
                      <el-card  class="card flex column justify-content" :body-style="{ padding: '0px' }">
                          <div class="flex justify-content" style="padding: 20px 0">
                              <img src="../assets/list_icon5.png" class="image">
                          </div>
                          <div class="flex justify-content card-font" >
                              <span style="font-size: 24px">结果直观</span>
                          </div>
                      </el-card>
                  </el-col>
                  <el-col :span="8">
                      <el-card  class="card flex column justify-content" :body-style="{ padding: '0px' }">
                          <div class="flex justify-content" style="padding: 20px 0">
                              <img src="../assets/list_icon6.png" class="image">
                          </div>
                          <div class="flex justify-content card-font" >
                              <span style="font-size: 24px">更多功能</span>
                          </div>
                      </el-card>
                  </el-col>
              </el-row>
          </div>
          <div class="survey-title flex column justify-content align-items" style="margin-top: 88px">
              <div>操作简单</div>
              <div class="border"></div>
          </div>
          <div class="operation">
              <div class="operation-box flex">
                  <div class="operation-box-left">
                      <img src="../assets/img_1.jpg" alt="">
                  </div>
                  <div class="operation-box-right">
                      <div style="margin-left:25%">
                          <div class="flex align-items num" >
                              <img src="../assets/pic_one.png" alt="">
                              <span class="operation-content">设计调查问卷</span>
                          </div>
                          <div class="introduce">
                              单选、多选、矩阵、投票、评分...总计29种题型随意选择 <br>
                              跳题、关联逻辑、选项引用、轻松实现多种复杂跳转 <br>
                              问卷批量导入，快速生成已有问卷 <br>
                              免费模板、免费皮肤之间使用，一键生成高质量问卷
                          </div>
                      </div>
                  </div>
              </div>
              <div class="operation-box flex">
                  <div class="operation-box-right">
                      <div style="margin-left:15%">
                          <div class="flex align-items num" >
                              <img src="../assets/pic_two.png" alt="">
                              <span class="operation-content">一键发布问卷</span>
                          </div>
                          <div class="introduce">
                              自动生成多渠道链接及二维码，便于对外投放 <br>
                              自定义进行分享配置，助力品牌形象宣传 <br>
                              支持分享到微信等社交平台，便于不同渠道宣传 <br>
                              手机、电脑、平板多端适配，支持问卷导出
                          </div>
                      </div>
                  </div>
                  <div class="operation-box-left" >
                      <div style="margin-left: 15%"><img src="../assets/img_2.jpg" alt=""></div>
                  </div>
              </div>

              <div class="operation-box flex">
                  <div class="operation-box-left">
                      <img src="../assets/img_3.jpg" alt="">
                  </div>
                  <div class="operation-box-right">
                      <div style="margin-left:25%">
                          <div class="flex align-items num" >
                              <img src="../assets/pic_thr.png" alt="">
                              <span class="operation-content">数据回收统计</span>
                          </div>
                          <div class="introduce">
                              多种筛选条件配置，可按需要查找数据及交叉分析 <br>
                              多种数据导出方式，原始数据可直接导入Excel <br>
                              可按条件筛选你需要的答卷，可按需进行交叉分析 <br>
                              支持分题统计，数据结果自动生成柱状图
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="establish flex justify-content">
              <div class="font-bottom">
                  <p style="color: #fff;font-size: 40px;margin-top: 70px">快来创建您的第一个项目吧</p>
                  <p style="font-size: 28px;color: #fff;margin-top: 40px">专业问卷调查，全方位满足你的调研需求</p>
              </div>
              <div class="flex align-items">
                  <div class="b-tn flex align-items justify-content" @click="add">立即创建</div>
              </div>
          </div>
      </div>
      <!-- <div style="height: 200px"></div> -->
	  <HeadFooter></HeadFooter>
  </div>
</template>

<script>
    import HeadNav from '@/components/HeadNav';
	import HeadFooter from "@/components/HeadFooter";
    export default {
        name: "Survey",
        components:{
            HeadNav,
			HeadFooter
        },
        data(){
            return {

            }
        },
        methods:{
            add(){
                this.$router.push({path:'/my'})
            }
        }
    }
</script>
<style scoped>

</style>
<style>
    .bgcImage{
        background: url("../assets/banner_btn.png") no-repeat;
        text-align:center;
        width: 160px;
        height: 52px;
        color: #fff;
        font-size: 24px;
        cursor: pointer;
        line-height: 52px;
        left:46%;
        position: absolute;
        bottom: 95px;
    }
    .banner-btn{
        width: 160px;
        height: 52px;
        color: #fff;
        background: url("../assets/banner_btn.png") no-repeat;
        font-size: 24px;
        cursor: pointer;
        line-height: 52px;
        margin-bottom: 95px;
    }
  .survey-banner{
      height: 550px;
      width: 100%;
      background: url("../assets/banner-survey.png") no-repeat center;
      margin-top: 5px;
      align-items: flex-end;
      position:relative;
  }
    .use{
        margin-top: 50px;
    }
    .survey-title{
        font-size: 26px;
        color: #333;
        margin-top: 50px;
    }
  .border{
      width:130px;
      height: 3px;
      float:left;
      background: #0080ff;
      margin-top: 15px;
  }
    .icon-list{
        margin-top: 20px;
    }
    .border{
        width:64px;
        height:4px;
        float:left;
        margin-left:0px;
    }
    .card{
        border-radius: 15px;
        height: 290px;
        cursor: pointer;
    }
    .card:hover{
        box-shadow: 1px 3px 17px -5px #aeaeae;
        transform: translateY(-5px);
        transition: 0.3s;
    }
    .image{
        width: 134px;
        height: 134px;
    }
    .card-font{
        margin-top: 10px;
    }
    .operation{
        margin-top: 50px;
    }
    .operation-box{
        margin-top: 100px;
    }
    .operation-box-left{
        flex: 1;
    }
    .operation-box-left img{
        width: 664px;
    }
  .operation-box-right{
      flex: 1;
      height: 490px;
  }
    .num{
       margin-top: 99px;
    }
    .operation-content{
        font-size: 26px;
    }
    .introduce{
        font-size: 16px;
        margin-top: 30px;
        color: #333;
        line-height: 40px;
    }
    .establish{
        width: 100%;
        height:300px;
        background: url("../assets/banner_bot.png") no-repeat center;
        margin-top: 100px;
     }
     .b-tn{
         width: 204px;
         height: 72px;
         border-radius: 5px;
         background: #fff;
         color: #0080ff;
         font-size: 28px;
         cursor: pointer;
         margin-left: 150px;
     }
     .el-menu--horizontal>.el-menu-item.is-active {
        border-bottom: 0px solid #409EFF;
        color: #333;
        position: relative;
    }
</style>